var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor"},[React.createElement("path",{"d":"M24.89 13.7H0v-3.112h24.89z","key":0}),React.createElement("path",{"d":"M27.443 12.507 15.45 24.5l-2.2-2.2 11.995-11.994z","key":1}),React.createElement("path",{"d":"m24.248 13.7-11-11 2.2-2.2 11 11z","key":2})]));
}

ArrowRight.defaultProps = {"fill":"none","viewBox":"0 0 28 25"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
